(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bp-list-collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  var validSorts = [
    'alphabetical',
    'alphabetical_reversed',
    'products_high',
    'products_low',
    'date_reversed',
    'date'
  ];

  function getSortValue(item, key) {
    if (key === 'title') return (item.dataset.sortTitle || '').trim();
    if (key === 'products') return Number(item.dataset.sortProducts || 0);
    if (key === 'published') return Number(item.dataset.sortPublished || 0);
    return '';
  }

  function sortCollectionList(sortBy) {
    document.querySelectorAll('.bplc__grid').forEach(function (grid) {
      var items = Array.prototype.slice.call(grid.children);

      items.sort(function (a, b) {
        if (sortBy === 'products_high' || sortBy === 'products_low') {
          var productsA = getSortValue(a, 'products');
          var productsB = getSortValue(b, 'products');
          return sortBy === 'products_high' ? productsB - productsA : productsA - productsB;
        }

        if (sortBy === 'date_reversed' || sortBy === 'date') {
          var dateA = getSortValue(a, 'published');
          var dateB = getSortValue(b, 'published');
          return sortBy === 'date_reversed' ? dateB - dateA : dateA - dateB;
        }

        var titleA = getSortValue(a, 'title');
        var titleB = getSortValue(b, 'title');
        var direction = sortBy === 'alphabetical_reversed' ? -1 : 1;
        return titleA.localeCompare(titleB, undefined, { sensitivity: 'base' }) * direction;
      });

      items.forEach(function (item) {
        grid.appendChild(item);
      });
    });
  }

  var params = new URLSearchParams(window.location.search);
  var requestedSort = params.get('sort_by');
  var selects = document.querySelectorAll('.bplc__sort-select');
  var activeSort = validSorts.indexOf(requestedSort) > -1
    ? requestedSort
    : selects[0] && validSorts.indexOf(selects[0].value) > -1
      ? selects[0].value
      : 'alphabetical';

  selects.forEach(function (select) {
    select.value = activeSort;

    select.addEventListener('change', function () {
      params.set('sort_by', select.value);
      params.delete('page');
      window.location.search = params.toString();
    });
  });

  sortCollectionList(activeSort);

  document.querySelectorAll('.bplc__grid.bp-reveal').forEach(function (el) {
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06 }).observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categories-busterpro"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Reveal animation
  var grids = document.querySelectorAll('.bp-categories__grid.bp-reveal');
  if (grids.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    grids.forEach(function (el) { observer.observe(el); });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-busterpro"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.fp__grid.bp-reveal').forEach(function (el) {
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 }).observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal-busterpro"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.jnl__grid.bp-reveal').forEach(function (el) {
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06 }).observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-busterpro"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.lb__grid.bp-reveal').forEach(function (el) {
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06 }).observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-brand"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.sbr__grid.bp-reveal').forEach(function (el) {
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06 }).observe(el);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ss__grid.bp-reveal').forEach(function (el) {
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06 }).observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stringing-room"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.sr__grid.bp-reveal').forEach(function (el) {
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 }).observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-busterpro"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.tst.bp-reveal').forEach(function (el) {
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 }).observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
